window.VjsUtility = (function(my){
    var self = my.Popup = {};

    //this will hold the instance of the popup
    //this should be like a singleton
    var _popup = null;

    self.init = function (settings) {
        _popup = new Popup();
        _popup.render(settings);
    };

    self.close = function () {
        _popup.close();
    };

    var Popup = function () {};
    Popup.prototype = {
        /**
         *  @desc title of the popup
         */
        title: null,

        /**
         *  @desc content of the popup
         */
        content: null,

        /**
         *  @desc width of the popup
         */
        width: "600px",

        /**
         *  @desc height of the popup
         */
        height: "auto",

        /**
         *  @desc transition type for popup
         *      possible values  [fade, slide-right, slide-top]
         */
        transition: "fade",

        /**
         *  @desc id of popup background
         */
        backgroundId: "#vjs-popup-background",

        /**
         *  @desc classes to add to popup background
         */
        backgroundClasses: null,

        /**
         *  @desc id of popup body
         */
        bodyId: "#vjs-popup-body",

        /**
         *  @desc classes to add to the popup body
         */
        bodyClasses: null,

        /**
         *  @desc content container id
         */
        contentId: "#vjs-popup-content",

        /**
         *  @desc which type of icon for the close icon
         *      possible values
         *      fa = font awesome
         *      all other with be an X
         */
        iconType: "fa",

        /**
         *  @desc should we hide the title bar?
         *       true / false
         */
        hideTitle: false,

        //???
        after: null,
        onRender: null,
        onClose: null,

        /**
         *  @desc popup html
         */
        html: {
            background: function () {
                return "<div class='vjs-popup-background " + (this.backgroundClasses ? this.backgroundClasses : "") + "' id='vjs-popup-background'></div>";
            },
            body: function () {
                var titleBar = ''
                    + '<div class="vjs-popup-title-container">'
                    + '	<div class="vjs-popup-title" id="vjs-popup-title"></div>'
                    + '	<div id="vjs-popup-notification" class="vjs-popup-notification"></div>'
                    + '</div>';

                var compiledBody = ""
                    + '<div class="vjs-popup-body ' + (this.transition ? this.transition : '') +  ' '  // add the transition class
                    + (this.bodyClasses ? this.bodyClasses : '') + '" id="vjs-popup-body">'        // add the custom body classes
                    + (this.hideTitle ? '' : titleBar)
                    +   '<div class="vjs-popup-close" id="vjs-popup-close" tabindex="0" aria-label="close popup">' + this.html.icon.call(this) + '</div>'
                    +   '<div class="vjs-popup-content" id="vjs-popup-content"></div>'
                    + "</div>";

                return compiledBody;
            },
            icon: function () {
                switch (this.iconType) {
                    case "fa":
                        return "<i class='fa fa-times vjs-popup-close-icon'></i>";
                    default:
                        return "<span class='vjs-popup-close-icon'>X</span>";
                }
            }
        },

        render: function (settings) {
            //set any settings passed in
            this.title               = settings.title                ? settings.title               : this.title;
            this.content             = settings.content              ? settings.content             : this.content;
            this.width               = settings.width                ? settings.width               : this.width;
            this.height              = settings.height               ? settings.height              : this.height;
            this.transition          = settings.transition           ? settings.transition          : this.transition;
            this.backgroundClasses   = settings.backgroundClasses    ? settings.backgroundClasses   : this.backgroundClasses;
            this.bodyClasses         = settings.bodyClasses          ? settings.bodyClasses         : this.bodyClasses;
            this.iconType            = settings.iconType             ? settings.iconType            : this.iconType;
            this.hideTitle           = settings.hideTitle            ? settings.hideTitle           : this.hideTitle;
            this.after               = settings.after                ? settings.after               : this.after;

            //not using these yet
            //or ever will
            this.onClose             = settings.onClose              ? settings.onClose             : this.onClose;
            this.onRender            = settings.onRender             ? settings.onRender            : this.onRender;

            //test if popup already exists
            this._testIfPopupExists();

            //add the background html to the page
            $("body")
                .addClass("body-stop-scroll")
                .append(this.html.background.call(this));

            // $(".vjs-header-container, .vjs-main-container, .vjs-footer-container").addClass("blur");
            var popup = $(this.html.body.call(this));
            popup.find("#vjs-popup-title").html(this.title);
            popup.find("#vjs-popup-content").html(this.content);
            popup.appendTo(this.backgroundId);

            $(".vjs-popup-close").focus();

            if (typeof this.onRender === "function") {
                this.onRender();
            }

            // Wire close behavior. The legacy implementation did this
            // through my.View.extend with a handlebars templateUrl/dataUrl
            // path, which ran Handlebars.compile() at runtime and violated
            // the app's CSP (no 'unsafe-eval'). Callers now pass content
            // inline via settings.content (set above on line 152), so we
            // just bind the close events and invoke settings.after.
            var that = this;
            $("body").off("click.vjsPopup", "#vjs-popup-close");
            $("body").on("click.vjsPopup", "#vjs-popup-close", function () {
                that.close();
            });
            $("body").off("keyup.vjsPopup", "#vjs-popup-body");
            $("body").on("keyup.vjsPopup", "#vjs-popup-body", function (e) {
                var keyPressed = (e.keyCode ? e.keyCode : e.which);
                if (keyPressed == 27) {
                    that.close();
                }
            });

            if (typeof this.after === "function") {
                this.after.call(this);
            }
        },

        /**
         *  @desc this will check if popup exists, and if so it will remove it
         *      only one popup allowed at a time
         */
        _testIfPopupExists: function () {
            var $popup = $(this.backgroundId)
            if($popup.is(":visible")){
                $popup.detach().remove();
            }
        },

        close: function (e) {
            //see if need to return focus to another element
            if (this.focusReturn) {
                $(this.focusReturn).focus();
            }

            //see if they have a callback
            if(typeof this.closeCallBack === "function"){
                this.closeCallBack();
            }

            $("body").removeClass("body-stop-scroll");
            $("#vjs-popup-background")
                .fadeOut(function () {
                    $(this).detach().remove();
                });

            if (typeof this.onClose === "function"){
                this.onClose();
            }
        }
    };

    return my;
}(window.VjsUtility || {}));
